<template>
    <div class="qr-reader-wrapper flex flex-col">
        <p class="error text-red text-center pb-4" v-if="noFrontCamera">
            Laitteessasi ei ole toista kameraa, tai kyseinen laite ei toimi selaimessasi.
        </p>
        <qrcode-stream @decode="onDecode" @init="onInit"></qrcode-stream>
        <button
            class="btn btn-default mr-auto ml-auto mt-6"
            @click="switchCamera">
            Vaihda kameraa
        </button>
        <div
            class="bg-teal-lightest border-t-4 border-teal rounded-b text-teal-darkest px-4 py-3 shadow-md mt-8"
            role="alert">
            <div class="flex">
                <div class="py-1">
                    <svg
                        class="fill-current h-8 w-8 text-teal mr-4" xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20">
                        <path
                            d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"></path>
                    </svg>
                </div>
                <div>
                    <p class="font-bold">INFO</p>
                    <p class="text-md">Selain pyytää lupaa käyttää laitteesi kameraa kun lataat tämän sivun. Jos kameran
                                       näkymä ei aukea automaattisesti luvan annettuasi, on mahdollista että laitteesi
                                       ei ole yhteensopiva tämän QR-lukijaohjelmiston kanssa.</p>
                    <p class="text-md mt-2">
                        Varusmies saa QR-koodin esiin menemällä valitsemansa aktiviteetin sivulle, ja klikkaamalla
                        'Sisään QR'/'Ulos QR' -painiketta, kun aktiviteetti on alkamassa tai päättymässä. Näyttämällä
                        kyseistä QR-koodia tämän sivun lukijaan, ohjelmisto kirjaa varusmiehen sisään tai ulos,
                        tilanteesta riippuen.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from 'vue-qrcode-reader';
    import Swal from 'sweetalert2/dist/sweetalert2.js';
    import axios from 'axios';

    const REAR_CAMERA = { ideal: 'environment' };
    const FRONT_CAMERA = { exact: 'user' };

    export default {
        components: {
            QrcodeStream,
            QrcodeDropZone,
            QrcodeCapture
        },

        data() {
            return {
                facingMode: REAR_CAMERA,
                noFrontCamera: false
            }
        },
        methods: {
            async onInit(promise) {
                try {
                    await promise
                } catch (error) {
                    this.noFrontCamera = this.facingMode === FRONT_CAMERA
                        && error.name === 'OverconstrainedError';

                    console.error(error)
                }
            },
            switchCamera() {
                if (this.facingMode === FRONT_CAMERA) {
                    this.facingMode = REAR_CAMERA
                } else {
                    this.facingMode = FRONT_CAMERA
                }
            },
            onDecode(decodedString) {
                if (!decodedString) return;

                const [attendeeId, activityId, action, timestamp] = decodedString.split(';');

                if (!attendeeId || !activityId || !action || !timestamp) this.displayError();

                if (action === 'checkin') {
                    this.performCheckIn(attendeeId, activityId, timestamp);
                }
                if (action === 'checkout') {
                    this.performCheckOut(attendeeId, activityId, timestamp);
                }
            },
            performCheckIn(attendeeId, activityId, timestamp) {
                return axios.post(`/api/checkin/activity/${activityId}`, {
                    datetime: timestamp,
                    attendee_id: attendeeId
                })
                    .then(() => {
                        this.displaySuccess('Sisäänkirjaus onnistui!');
                    })
                    .catch(error => {
                        if (error.response.data.errors.title) {
                            this.displayError(error.response.data.errors.title);
                        } else {
                            this.displayError('Sisään epäonnistui, yritä uudelleen ja ota tarvittaessa yhteys ylläpitäjään');
                        }
                    });
            },
            performCheckOut(attendeeId, activityId, timestamp) {
                return axios.post(`/api/checkout/activity/${activityId}`, {
                    datetime: timestamp,
                    attendee_id: attendeeId
                })
                    .then(() => {
                        this.displaySuccess('Uloskirjaus onnistui!');
                    })
                    .catch(error => {
                        if (error.response.data.errors.title) {
                            this.displayError(error.response.data.errors.title);
                        } else {
                            this.displayError('Uloskirjaus epäonnistui, yritä uudelleen ja ota tarvittaessa yhteys ylläpitäjään');
                        }
                    });
            },
            displayError(text) {
                Swal.fire({
                    type: 'error',
                    title: 'Kirjaus epäonnistui!',
                    text: text ? text : 'QR-Koodin luku epäonnistui, yritä uudelleen',
                    timer: 3000
                })
            },
            displaySuccess(text) {
                Swal.fire({
                    type: 'success',
                    title: text,
                    timer: 1500
                })
            }
        }
    }
</script>
<style lang="scss">
    .qrcode-stream {
        .qrcode-reader {
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-around;
            align-items: center
        }

        .qrcode-reader__inner-wrapper {
            position: relative;
            max-width: 100%;
            max-height: 100%;
            z-index: 0
        }

        .qrcode-reader__overlay, .qrcode-reader__tracking-layer {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0
        }

        .qrcode-reader__camera, .qrcode-reader__pause-frame {
            display: block;
            object-fit: contain;
            max-width: 100%;
            max-height: 100%
        }

        .qrcode-stream {
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-around;
            align-items: center
        }

        .qrcode-stream__inner-wrapper {
            position: relative;
            max-width: 100%;
            max-height: 100%;
            z-index: 0
        }

        .qrcode-stream__overlay, .qrcode-stream__tracking-layer {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0
        }

        .qrcode-stream__camera, .qrcode-stream__pause-frame {
            display: block;
            object-fit: contain;
            max-width: 100%;
            max-height: 100%
        }
    }
</style>
